import { createSlice } from '@reduxjs/toolkit';

const permissionSlice = createSlice({
    name: 'permission',
    initialState: {
        permissions: null,
        hash: null,
        loading: false,
        error: null,
    },
    reducers: {
        setPermissions: (state, action) => {
            const { permissions, hash } = action.payload;
            state.permissions = permissions;
            state.hash = hash;
            state.loading = false;
            state.error = null;
        },
        setPermissionsLoading: (state) => {
            state.loading = true;
        },
        setPermissionsError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        clearPermissions: (state) => {
            state.permissions = null;
            state.hash = null;
            state.loading = false;
            state.error = null;
        },
    },
});

export const {
    setPermissions,
    setPermissionsLoading,
    setPermissionsError,
    clearPermissions,
} = permissionSlice.actions;

export const selectPermissions = (state) => state.permission?.permissions;
export const selectPermissionHash = (state) => state.permission?.hash;
export const selectPermissionsLoading = (state) => state.permission?.loading;
export const selectPermissionsError = (state) => state.permission?.error;

export default permissionSlice.reducer;
